import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faNewspaper,
  faBookOpen,
  faDesktop,
  faBrain,
  faPeopleGroup
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const LCMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/limbus-company/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/limbus-company/identities">
        <Nav.Link as="span" eventKey="identities" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Identities</span>
        </Nav.Link>
      </Link>
      <Link to="/limbus-company/ego">
        <Nav.Link as="span" eventKey="ego" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBrain} width="18" /> <span>EGO</span>
        </Nav.Link>
      </Link>
      <Link to="/limbus-company/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/limbus-company/team-builder">
        <Nav.Link as="span" eventKey="items" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faPeopleGroup} width="18" />{' '}
          <span>Team builder</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/limbus-company/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/limbus-company/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
      <hr />
      <Link to="/limbus-company/play-on-pc">
        <Nav.Link
          as="span"
          className="special"
          eventKey="play-on-pc"
          onClick={handleOnClick}
        >
          <FontAwesomeIcon icon={faDesktop} width="18" />{' '}
          <span>Play on PC</span>
        </Nav.Link>
      </Link>
    </Nav>
  );
};
